import React from 'react';
import cx from 'classnames';
import styles from './Modal.module.scss';

function ModalFooter(props) {
  const { className, children, ...rest } = props;
  return (
    <footer className={cx(styles.modalFooter, className)} {...rest}>
      {children}
    </footer>
  );
}

export default ModalFooter;
